import { useBoolean } from 'usehooks-ts';

export default function useCaptureScreenshot() {
  const { value: isCapturing, setTrue: setCapturing, setFalse: setNotCapturing } = useBoolean(false);

  const handleCapture = async (container: HTMLElement | null | undefined): Promise<Blob> => {
    if (!container) return Promise.reject('INVALID_CAPTURE_TARGET');

    setCapturing();
    const result = await captureScreenshot(container);
    setNotCapturing();

    return result;
  };

  return {
    capture: handleCapture,
    isCapturing,
  };
}

async function captureScreenshot(container: HTMLElement, previousBlob?: Blob): Promise<Blob> {
  try {
    const { toBlob: htmlToImageBlob } = await import('html-to-image');

    const blob = await htmlToImageBlob(container, { pixelRatio: 2 });

    if (!blob) return Promise.reject('FAILED_TO_CAPTURE_IMAGE');

    if (blob.size !== previousBlob?.size) {
      return captureScreenshot(container, blob);
    }

    return blob;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  }
}
